import { ICON_IMAGE_URLS } from "../utils/iconImageMap";

// Aktualisierte Course-Schema-Funktion
export function generateCourseSchema(course) {
  return {
    "@context": "https://schema.org",
    "@type": "Course",
    "name": course.title,
    "description": Array.isArray(course.description)
      ? course.description.join(" ")
      : course.description,
    "url": `https://www.denisbitter.de/course/${course.slug}`,
    "image": ICON_IMAGE_URLS[course.icon] || ICON_IMAGE_URLS.default,
    "provider": {
      "@type": "Organization",
      "name": "Denis Bitter",
      "sameAs": "https://www.denisbitter.de",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.denisbitter.de/images/b_gray.png"
      }
    },
    "author": {
      "@type": "Person",
      "name": course.instructor || "Denis Bitter"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": course.ratingValue || 5,
      "reviewCount": course.registeredCount || 1
    }
  };
}

// Aktualisiertes FAQ-Schema mit persönlicher Sprache
export function buildFAQData(mapping = {}) {
  const questions = Object.entries(mapping).flatMap(([category, terms]) =>
    terms.map((term) => ({
      "@type": "Question",
      "name": `Was lerne ich bei ${term}?`,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": `In meinen Kursen zu ${term} lernst du praxisnah, wie du das Wissen direkt anwenden kannst – klar, menschlich, wirksam.`
      }
    }))
  );

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": questions
  };
}
